import React from "react";
import { ArrowUpRight } from "lucide-react";

const projects = [
  { name: "KYC360", type: "Web App", stack: ["Angular", ".NET Core", "SQL Server"], text: "KYC management platform with secure workflows, approvals and admin controls.", img: "img/portfolio/kyc360.png", featured: true },
  { name: "MyMor", type: "Mobile Platform", stack: ["React Native", "Firebase"], text: "Community platform with real-time features and a scalable Firebase backend.", img: "img/portfolio/mymor.jpeg", featured: true },
  { name: "Ticket Booking System", type: "Web App", stack: ["Angular", ".NET Core"], text: "Booking platform with admin dashboard, listings management and reporting.", img: "img/portfolio/tbs.jpg" },
  { name: "Himachal Gramin Hut", type: "App / Web", stack: ["React Native", ".NET Core"], text: "Mobile-first marketplace with backend APIs and database-driven content.", img: "img/portfolio/hgh.jpg" },
  { name: "Services App", type: "Mobile App", stack: ["React Native", ".NET Core"], text: "Service management app with authentication flows and backend integration.", img: "img/portfolio/esms.jpg" },
];

export const Portfolio = () => {
  return (
    <section id="portfolio" className="relative bg-[#05070f] py-24 overflow-hidden">
      <div className="absolute top-1/3 -left-10 w-[420px] h-[420px] rounded-full bg-cyan-700/10 blur-[130px]" />
      <div className="relative max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <span className="eyebrow reveal">Our Work</span>
            <h2 className="reveal d1 mt-5 font-display text-white text-3xl md:text-5xl">
              Products we've <span className="text-gradient">shipped</span>
            </h2>
            <p className="reveal d2 mt-4 text-slate-400 text-base md:text-lg">
              Selected projects delivered across web, mobile, backend APIs and databases.
            </p>
          </div>
          <a
            href="#contact"
            className="reveal d2 hidden md:inline-flex items-center gap-2 px-5 py-3 rounded-full font-extrabold text-white glass-strong hover:bg-white/10 transition self-start"
          >
            Start yours <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((p, i) => (
            <article
              key={p.name}
              className={`reveal d${(i % 3) + 1} group relative rounded-3xl overflow-hidden glass ${
                p.featured ? "sm:col-span-2 lg:col-span-2" : ""
              }`}
            >
              <div className={`relative overflow-hidden ${p.featured ? "h-[300px]" : "h-[230px]"}`}>
                <img
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#05070f] via-[#05070f]/40 to-transparent" />

                <span className="absolute top-4 left-4 text-xs font-bold text-white px-3 py-1 rounded-full bg-blue-600/80 backdrop-blur-sm">
                  {p.type}
                </span>

                <div className="absolute inset-x-0 bottom-0 p-6 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="text-xl md:text-2xl font-display text-white">{p.name}</h3>
                    <span className="h-9 w-9 shrink-0 rounded-full grid place-items-center bg-white/10 border border-white/20 text-white opacity-0 group-hover:opacity-100 transition">
                      <ArrowUpRight className="h-4 w-4" />
                    </span>
                  </div>
                  <p className="mt-2 text-slate-300 text-sm leading-relaxed max-h-0 opacity-0 group-hover:max-h-24 group-hover:opacity-100 transition-all duration-500">
                    {p.text}
                  </p>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {p.stack.map((t) => (
                      <span key={t} className="text-[11px] font-bold text-white/90 px-2.5 py-1 rounded-full bg-white/10 border border-white/15 backdrop-blur-sm">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
